import { VideoJob } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateVideoJobArgs,
    getDefaultVideoJobCreateArgs,
    UpdateVideoJobArgs,
} from "@nova/serializer/src/client/validators/jobs/video"
import { addEntitySocket, updateEntitySocket } from "features/entity-caching/project/slice"
import { selectActivatedFireId } from "features/map/control/selectors"
import { selectActiveWorkspace } from "features/data-management/workspace/WorkspaceManagementSlice"

const {
    create: createVideoJob,
    update: updateVideoJob,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    VideoJob, // entity type
    CreateVideoJobArgs, // create args to send to server
    ["srtPath", "videoPath", "metadataPath"], // create args required by action
    UpdateVideoJobArgs, // update args
    { file?: string; flightId: string }, // context required by action
    {
        flightId: string
        file?: string
        portfolioName?: string
        portfolioId?: string
        projectId?: string
    } // context required by server
>("VideoJob")

export const addVideoJobsToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data, context } }, socket) => {
            if (!context?.file || !context.flightId) throw "Missing file or flightId"

            const state = store.getState()
            const projectId = selectActivatedFireId(state)!
            const org = selectActiveWorkspace()(state)!
            const serverContext = {
                file: context.file,
                flightId: context.flightId,
                portfolioName: org.name,
                portfolioId: org.id,
                projectId,
            }
            createVideoJob(socket, data, serverContext)
            store.dispatch(
                addEntitySocket({
                    data: { ...data, ...getDefaultVideoJobCreateArgs() },
                    path: ["videoFlights", { id: context.flightId }, "job"],
                })
            )
        })
        .addCase(updateAction, (store, { payload: { updates, context } }, socket) => {
            updateVideoJob(socket, context.flightId, updates, {
                flightId: context.flightId,
            })
            store.dispatch(
                updateEntitySocket({
                    updates,
                    path: ["videoFlights", { id: context.flightId }, "job"],
                })
            )
        })
export {
    createAction as createVideoJob,
    updateAction as updateVideoJob,
    deleteAction as deleteVideoJob,
}
